import { primaryLinkStyles } from "shared/styles/linkStyles";
import styled from "styled-components";

export const StyledLink = styled.a(({ theme }) => primaryLinkStyles({ theme }));
